import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import { confirmable } from 'react-confirm';

class Confirmation extends React.Component {

    render() {
        const {
            confirmation,
            show,
            proceed,
            dismiss,
            cancel,
        } = this.props;
        return (
            <Dialog
                open={show}
                onClose={dismiss}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {confirmation}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => cancel('arguments will be passed to the callback')} color="primary">
                        ไม่ใช่
      </Button>
                    <Button onClick={() => proceed('same as cancel')} color="primary" autoFocus>
                        ใช่
      </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default confirmable(Confirmation);